import { ThemeProvider } from '@mui/material';
import { ReactNode, useEffect } from 'react';
import { darkTheme, lightTheme } from './mui-theme';
import { useUiStore } from './stores/ui.store';

interface AppThemeProviderProps {
  children: ReactNode;
}

/**
 * Applies the persisted theme mode to MUI and the document `data-theme` attribute
 * so CSS-variable theming in ui.css stays in sync with the MUI palette.
 */
export function AppThemeProvider({ children }: AppThemeProviderProps) {
  const themeMode = useUiStore((state) => state.themeMode);
  const isDark = themeMode === 'dark';

  useEffect(() => {
    if (isDark) {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-theme');
    }
  }, [isDark]);

  return <ThemeProvider theme={isDark ? darkTheme : lightTheme}>{children}</ThemeProvider>;
}
